// #genai
import AddAchPaymentMethod from './AddAchPaymentMethod.component';

export default AddAchPaymentMethod;
